import classNames from 'classnames';
import React, { useState, useRef, useEffect } from 'react';
import styles from './style.module.scss';
import Heading from 'shared/components/common/heading/Heading';
import { logoSite, Printer } from 'assets';
import CustomButton from 'shared/components/common/custom_button/CustomButton';
import { useReactToPrint } from 'react-to-print';
import { useLocation } from 'react-router-dom';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import moment from 'moment';
import ImageViewer from '../manage_task/ImageViewer';

export default function LayoutSo() {
    const componentRef = useRef(null);
    const location = useLocation();
    const handlePrint = useReactToPrint({
        content: () => componentRef.current
    });
    const [dataSO, setdataSO] = useState(location.state.data);
    const [address, setAddress] = useState('Shop # 54,Ground Floor,Century Tower,Main Link Road.');
    const [city, setCity] = useState('Lahore, Punjab');
    const [postal, setPostal] = useState('54000');
    const [email, setEmail] = useState('Techbizzksa@gmail.com');

    useEffect(() => {
        if (location.state.data) {
            let clone = { ...location.state.data };
            let list = location?.state?.data?.order?.map((ii) => {
                return {
                    ...ii,
                    amount: (ii?.price || 0) * (ii?.quantity || 0)
                };
            });
            clone.order = list || [];
            setdataSO(clone);
        }
    }, [location.state.data]);

    const formatPrice = (price) => {
        const num = Number(price);
        if (isNaN(num)) return 'Rs 0.00';
        return `Rs ${num.toFixed(2)}`;
    };

    return (
        <div className={classNames(styles.mainpoLyout)}>
            <div className={classNames(styles.butoonprint)}>
                <CustomButton Icon={Printer} submitHandle={() => handlePrint()} IconStyle={classNames('me-1', styles.IconStyle)} text={'Print'} containerStyle={classNames(styles.AddProduct)} />
            </div>
            <div ref={componentRef} className={classNames(styles.UserContainer)}>
                <div className={classNames(styles.ourdress, styles.totalsPo)}>
                    <div className={classNames(styles.cusFlex)}>
                        <h4><img src={logoSite} alt="logo" />Wise Tech</h4>
                        <div className={styles.printLabelGroup}>
                            <label>Address:</label>
                            <input
                                className={styles.printOnlyHide}
                                value={address}
                                onChange={(e) => setAddress(e.target.value)}
                                placeholder="Address"
                            />
                            <span className={styles.printOnlyShow}>{address}</span>
                        </div>

                        <div className={styles.printLabelGroup}>
                            <label>City/State:</label>
                            <input
                                className={styles.printOnlyHide}
                                value={city}
                                onChange={(e) => setCity(e.target.value)}
                                placeholder="City/State"
                            />
                            <span className={styles.printOnlyShow}>{city}</span>
                        </div>

                        <div className={styles.printLabelGroup}>
                            <label>Postal Code:</label>
                            <input
                                className={styles.printOnlyHide}
                                value={postal}
                                onChange={(e) => setPostal(e.target.value)}
                                placeholder="Postal Code"
                            />
                            <span className={styles.printOnlyShow}>{postal}</span>
                        </div>

                        <div className={styles.printLabelGroup}>
                            <label>Email:</label>
                            <input
                                className={styles.printOnlyHide}
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="Email Address"
                            />
                            <span className={styles.printOnlyShow}>{email}</span>
                        </div>
                    </div>
                    <Heading heading={'Sale Order'} headingStyle={styles.Heading} />
                </div>
                <div className={classNames(styles.billingToPo)}>
                    <div className={classNames(styles.billto, styles.cusFlex)}>
                        <h6>Shipping Address / Bill to</h6>
                        <label>Name: {dataSO.shipping?.customerName || dataSO.supplier?.name || '-'}</label>
                        <label>Address: {dataSO.shipping?.address || dataSO.supplier?.address || '-'}</label>
                        <label>Phone: {dataSO.shipping?.phone || dataSO.supplier?.phone || '-'}</label>
                        {dataSO.shipping?.reference && <label>Reference: {dataSO.shipping.reference}</label>}
                    </div>
                    <div className={classNames(styles.billto)}>
                        <h6>Sale Order#:{dataSO?.order_number}</h6>
                        <div className="d-flex align-items-center">
                            <h6 className="mb-0">Date:</h6>
                            <span className="ps-2">{moment(dataSO?.created_at).format('DD, MMM YYYY')}</span>
                        </div>
                    </div>
                </div>
                <div className={classNames(styles.poItems)}>
                    <table border="0" className={classNames(styles.cusTable)}>
                        <thead>
                            <tr>
                                <th style={{ width: '30%' }}>Description</th>
                                <th style={{ width: '15%' }}>SKU</th>
                                <th style={{ width: '15%' }}>Quantity</th>
                                <th style={{ width: '15%' }}>Rate/per</th>
                                <th style={{ width: '15%' }}>Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            {dataSO?.order?.map((Item, inx) => (
                                <tr key={inx}>
                                    <td>
                                        <div>
                                            {Item.brand?.name && <div>{Item.brand?.name}</div>}
                                            <strong>{Item.product?.name || Item.sku}</strong>
                                            <div>
                                                {[Item.product_category?.name, Item.sub_category?.name, Item.color].filter(Boolean).join(', ')}
                                            </div>
                                        </div>
                                    </td>
                                    <td>{Item?.sku}</td>
                                    <td>{Item.quantity}</td>
                                    <td>{formatPrice(Item.price)}</td>
                                    <td>{formatPrice(Item.amount)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                    <div className={classNames(styles.ourdress, styles.subtotle)}>
                        <div className={classNames(styles.custmstotal)}>
                            <div className={classNames(styles.subtotleItems)}>
                                <h6>Total</h6>
                                <label>
                                    {formatPrice(
                                        dataSO?.order
                                            ?.map((ii) => ii.amount)
                                            .reduce((accumulator, currentValue) => {
                                                return accumulator + currentValue;
                                            }, 0)
                                    )}
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={classNames(styles.reference)}>
                    <div className={classNames(styles.linkSite)}>
                        <a href="/">wisetech.com</a>
                    </div>
                    <div className={classNames(styles.logo)}>
                        <img src={logoSite} alt="logo" />
                    </div>
                </div>
            </div>
        </div>
    );
}
